import { useState, useEffect } from "react";
import { useUserActions } from "store";
import { OnboardingStep, SampleDeal } from "store/types/user";

export const useOnboardingConfig = () => {
  const [steps, setSteps] = useState<OnboardingStep[]>([]);
  const [deals, setDeals] = useState<SampleDeal[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const { getOnboardingConfigAction } = useUserActions();

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setLoading(true);
        const data = await getOnboardingConfigAction();
        setSteps(data.steps);
        setDeals(data.deals || []);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch onboarding config:", err);
        setError("Failed to load onboarding configuration");
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, [getOnboardingConfigAction]);

  return { steps, deals, loading, error };
};
